import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NSelect = _resolveComponent("NSelect")!

  return (_openBlock(), _createBlock(_component_NSelect, {
    "model-value": _ctx.modelValue,
    items: _ctx.options,
    disabled: !_ctx.hasCamera,
    selectonly: "",
    "onUpdate:modelValue": _ctx.updateValue
  }, null, 8, ["model-value", "items", "disabled", "onUpdate:modelValue"]))
}